import Box from '@mui/material/Box';

const Standalone = () => {
  return (
    <Box pr={2} sx={{ padding: '16px 16px 16px 241px' }}>
      <h1>Application is not available in Standalone mode.</h1>
    </Box>
  );
};

export default Standalone;
